<template>
  <div id="map" ></div>
  <!-- Time Slider -->
  <!-- <input
      type="range"
      id="time-slider"
      v-model="sliderValue"
      :min="0"
      :max="dates.length - 1"
      step="1"
    /> -->

    <div class="controls-container">
    <div id="year-label">Year: 2000</div>
    <!-- <input type="range" id="year-slider"> -->
    <input type="range" id="year-slider" min="1500" step="1">
    <button id="toggle-filter">Disable Filter</button>
  </div>
</template>
  
  <script setup>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import geoJson from "../assets/churchesA.json";
import geoJsonB from "../assets/churchesB.json";
import geoJsonC from "../assets/churchesC.json";
// import geoJsonPol from "../assets/Political.json";
// import geoJsonPol from "https://services1.arcgis.com/Ezk9fcjSUkeadg6u/ArcGIS/rest/services/SCP_Beta_3_for_Beth_WFL1/FeatureServer/1/query?where=1+%3D+1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnTrueCurves=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson&token=";
// import geoJsonEss from "../assets/Ecclesiastical.json";
// import geoJsonEss from "https://services1.arcgis.com/Ezk9fcjSUkeadg6u/ArcGIS/rest/services/SCP_Beta_3_for_Beth_WFL1/FeatureServer/2/query?where=1+%3D+1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnTrueCurves=false&returnExceededLimitFeatures=false&f=json";
import { ref, watch, reateApp, defineComponent, nextTick, computed } from "vue";
import PopupContent from "@/components/PopupContent.vue";
import { onMounted } from "vue";
//   import { store } from '@/store/index.js'

import { mapMutations, mapState, mapGetters, mapActions } from "vuex";

import { useStore } from "vuex"; // Import from 'vuex'
const store = useStore();

const { getSelectedLayer } = mapGetters(['getSelectedLayer']);

// const { map } = mapGetters({
//   // Map getters
//   count: (state) => state.map, // Getter function to access state
// });

// const { SET_MAP } = mapMutations({
//   // Map mutations
//   SET_MAP: "SET_MAP", // Mutation name
//   //   countDown: 'counter/decrement',
// });
//   export default {
// setup() {

  let projectIds = ref([]);
  let modernPlacename = ref([]);
  let district = ref([]);
  let state = ref([]);
  let country = ref([])
  let secularJuris = ref([])
  let bishop = ref([])
  let archbishop = ref([])
  let churchName = ref([])
  let typeSharing = ref([])
  let congregationsNum = ref([])
  let sharing = ref([])
  let protestants = ref([])
  let sharingStarted = ref([])
  let sharingEnded = ref([])
  let groupInChurch = ref([])
  const dates = ref([]);
  const sliderValue = ref(0);

// let geoJson = ref([])
onMounted(() => {
  mapboxgl.accessToken =
    "pk.eyJ1IjoibmF2ZWVlZCIsImEiOiJjbHc4c2QyeGQyaXd6MmxxdWZsMXd5MTV1In0.oJYL-ughhZosqXmg9wgEpg";
  const map = new mapboxgl.Map({
    container: "map",
    //   style: "mapbox://styles/mapbox/light-v9",
    style: "mapbox://styles/mapbox/streets-v10", // Replace with your preferred map style
    center: [12.455, 49.764],
    zoom: 5,
  });
  map.on("load", () => {
    map.addSource("churchesA", {
      type: "geojson",
      // Use a URL for the value for the `data` property.
      // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson'
      data: geoJson, //'churchesA.geojson'
    });


    map.addSource("churchesB", {
      type: "geojson",
      // Use a URL for the value for the `data` property.
      // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson'
      data: geoJsonB, //'churchesB.geojson'
    });

    map.addSource("churchesC", {
      type: "geojson",
      // Use a URL for the value for the `data` property.
      // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson'
      data: geoJsonC, //'churchesC.geojson'
    });

    // const params = {'f': 'pjson', 'username': 'naveedahmed_uagis', 'password': 'Tucson@1098', 'referer': 'https://www.arcgis.com', 'expiration': 21600}
    
    // const tokenURL = 'https://www.arcgis.com/sharing/rest/generateToken'
    // const response = requests.post(tokenURL, data = params, verify = False)
    // const token = response.json()['token'] 
    // console.log("token::", token)

 
    // import geoJsonPol from "https://services1.arcgis.com/Ezk9fcjSUkeadg6u/ArcGIS/rest/services/SCP_Beta_3_for_Beth_WFL1/FeatureServer/1/query?where=1+%3D+1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnTrueCurves=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson&token=";
// import geoJsonEss from "../assets/Ecclesiastical.json";
// import geoJsonEss from "https://services1.arcgis.com/Ezk9fcjSUkeadg6u/ArcGIS/rest/services/SCP_Beta_3_for_Beth_WFL1/FeatureServer/2/query?where=1+%3D+1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnTrueCurves=false&returnExceededLimitFeatures=false&f=json";

      map.addSource('esri-tiles', {
          type: 'raster',
          // tiles: ['https://tiles.arcgis.com/tiles/Ezk9fcjSUkeadg6u/arcgis/rest/services/1648_Political_Boundary/MapServer/tile/{z}/{y}/{x}'],
          tiles: ['https://tiles.arcgis.com/tiles/Ezk9fcjSUkeadg6u/arcgis/rest/services/europe/MapServer/tile/{z}/{y}/{x}'],
          tileSize: 256
        });




    console.log(store);
    store.commit('SET_MAP',map)
    store.commit('SET_CHAJSON',geoJson)

    //  extractProjIds();
    store.dispatch('extractProjIds'); // Dispatch the action here


    map.addLayer({
      id: 'esri-tiles',
      type: 'raster',
      source: 'esri-tiles',
      paint: {
          'raster-opacity': 0.7
      }
    });

// Assuming the ArcGIS service is a FeatureServer
map.addSource('politicalBndry', {
  type: 'geojson',
  data: 'https://services1.arcgis.com/Ezk9fcjSUkeadg6u/ArcGIS/rest/services/SCP_Beta_3_for_Beth_WFL1/FeatureServer/1/query?where=1+%3D+1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnTrueCurves=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pgeojson&token='
});

map.addSource('EssBndry', {
  type: 'geojson',
  data: 'https://services1.arcgis.com/Ezk9fcjSUkeadg6u/ArcGIS/rest/services/SCP_Beta_3_for_Beth_WFL1/FeatureServer/2/query?where=1+%3D+1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=*&returnGeometry=true&returnCentroid=false&returnEnvelope=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=false&cacheHint=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnTrueCurves=false&returnExceededLimitFeatures=false&f=geojson'
});

// If the source layer name is different, adjust it here
map.addLayer({
  id: "politicalBndry",
  type: 'line',
  source: 'politicalBndry',
  paint: {
    'line-color': 'red',
    'line-width': 2,
    'line-opacity': 0.5
  }
});

map.addLayer({
  id: "EssBndry",
  type: 'line',
  source: 'EssBndry',
  paint: {
    'line-color': 'purple',
    'line-width': 2,
    'line-opacity': 0.5
  }
});

map.loadImage('triangle.png', (error, image) => {
  if (error) throw error;
  map.addImage('triangle-icon', image); // Add triangle image to Mapbox
});

map.loadImage('square.png', (error, image) => {
  if (error) throw error;
  map.addImage('square-icon', image); // Add square image to Mapbox
});

map.loadImage('circle.png', (error, image) => {
  if (error) throw error;
  map.addImage('circle-icon', image); // Add circle image to Mapbox
});

  // Add a square symbol for churchesC
  map.addLayer({
      id: "churchesC",
      type: "symbol",
      source: "churchesC",
      layout: {
        "icon-image": "square-icon", // Custom square icon
        "icon-size": 0.2, // Adjust size as needed
        "icon-allow-overlap": true // Allow icons to overlap
      },
      paint: {
        "icon-color": "#00FF00", // Green color for square
        "icon-opacity": 0.9
      }
    });

        
    // Add a triangle symbol for churchesB
    map.addLayer({
      id: "churchesB",
      type: "symbol",
      source: "churchesB",
      layout: {
        "icon-image": "triangle-icon", // Custom triangle icon
        "icon-size": 0.2, // Adjust size as needed
        "icon-allow-overlap": true // Allow icons to overlap
      },
      paint: {
        "icon-color": "#FF0000", // Red color for triangle
        "icon-opacity": 0.9
      }
    });

    map.addLayer({
      id: "churchesA",
      type: "circle",
      source: "churchesA",
      paint: {
        "circle-radius": 6, // size of circles
        "circle-color": "#a6cee3", //'#00C5FF', // '#3D2E5D', //  color of circles
        "circle-stroke-color": "#000",
        "circle-stroke-width": 1,
        // "circle-opacity": 0.9,
      },
    });




    map.setLayoutProperty('EssBndry', 'visibility', 'none');
    map.setLayoutProperty('politicalBndry', 'visibility', 'none');
    map.setLayoutProperty('esri-tiles', 'visibility', 'none');

    // Set initial visibility
    map.setLayoutProperty('churchesA', 'visibility', 'visible');
    map.setLayoutProperty('churchesB', 'visibility', 'none');
    map.setLayoutProperty('churchesC', 'visibility', 'none');


    // store.dispatch('addLayer','EssBndry') 
    // store.dispatch('addLayer','politicalBndry')

    map.on("click", function (e) {
      console.log("store:: ",store.getters["getSelectedLayer"], " -- ::",e )

      // Query rendered features at the clicked point
      const feat = map.queryRenderedFeatures(e.point);
      let layerId = ''

    if (feat.length) {
      // Get the first feature
      const feature = feat[0];

      // Access the layer ID from the feature
      layerId = feature.layer.id;

      console.log("Layer ID:", layerId);

      // You can now use the layerId for further logic
      if (layerId === "churchesA") {
        console.log("Clicked on churchesA");
        // Your logic for churchesA layer click
      } else if (layerId === "churchesB") {
        console.log("Clicked on churchesB");
        // Your logic for churchesB layer click
      }  else if (layerId === "churchesC") {
        console.log("Clicked on churchesC");
        // Your logic for churchesB layer click
      } else {
        store.dispatch('closeDrawer')
        return
      }
    }
    
      const excludedLayers = ['churchesA', 'churchesB','churchesC'];

      const features = map.queryRenderedFeatures(e.point, {
        layers: [layerId], // replace with your layer name
      });
      // if (!features.length || !excludedLayers.includes(feature.layer.id) ) {
      //   store.dispatch('closeDrawer')
      //   return;
      // }
      const feature = features[0];
      console.log("feature prps::",feature.layer.id, feature.properties)
      // Gather the content you want to display in the drawer
      const drawerContent = {
          modernPlacename: feature.properties["Modern Placename"],
          projectObjectId: feature.properties["Project Object ID"],
          universalObjectId: feature.properties["Universal Object ID_Normdateien"],
          altSpelling: feature.properties["Alternative Spelling_Name (Parish)"],
          population: feature.properties["Population"],
          locationType: feature.properties["Location type"],
          modernDistrict: feature.properties["Modern District/County (Landeskreis/Bezirk"],
          modernState: feature.properties["Modern State (Bundesland/D partement/Canton)"],
          modernCountry: feature.properties["Modern Country"],
          // secularJurisdiction: feature.properties["Secular Jurisdiction"],
          secularJurisdiction: feature.properties["Early Modern Secular Ruler (Jurisdiction / Herrschaft)"],
          localReligiousReform: feature.properties["Ruler/Local religious reform"],
          otherGoverningEntities: feature.properties["Other governing Entities"],
          patronatsherr: feature.properties["kirchlicher Patronatsherr/Right of Presentation"],
          modernGemeinde: feature.properties["Modern Gemeinde_Pfarrei"],
          modernDekanat: feature.properties["Modern Dekanat"],
          bishop: feature.properties["Bishop"],
          archbishop: feature.properties["Archbishop"],
          churchName: feature.properties["Church Name (Modern)"],
          foundationDate: feature.properties["Foundation date_First Mention"],
          parishSaint: feature.properties["Parish Saint"],
          originalUsage: feature.properties["Original usage"],
          churchImages: feature.properties["Church Images"],
          survivalOfSharedChurch: feature.properties["Survival of Shared church"],
          historicalDescription: feature.properties["General Historical Description"],
          certaintyOfLocation: feature.properties["Certainty of location"],
          coordinates: feature.properties["Coordinates (decimal)"],
          latitude: feature.properties["Latitude"],
          longitude: feature.properties["Longitude"],
          preRefMonasticCongregation: feature.properties["Pre-Ref Monastic Congregation?"],
          beginPreRefSharing: feature.properties["Begin pre-ref sharing"],
          notesOnPreRefSharing: feature.properties["Notes on pre-reform sharing"],
          endPreRefSharing: feature.properties["End pre-ref Sharing"],
          typeOfSharing: feature.properties["Type of Sharing: Temporal, Spatial, Liturgical; other"],
          simultaneum: feature.properties["Official or Unofficial Simultaneum"],
          decree: feature.properties["Document (Decree, Treaty, Mandate, Agreement)"],
          eventsSharing: feature.properties["Events/Sharing"],
          numberOfCongregations: feature.properties["Number of congregations"],
          catholics: feature.properties["Catholic Groups"],
          protestants: feature.properties["Protestant Groups"],
          nonCoreligiousMonastic: feature.properties["Non-Coreligious Monastic (regula) Community?"],
          secondParish: feature.properties["Establish of 2nd Parish"],
          dateSharingStartedDeFacto: feature.properties["Date sharing Started (de facto)"],
          dateSharingStartedDeJure: feature.properties["Date sharing Started (de jure)"],
          dateSharingEndedDeFacto: feature.properties["Date sharing Ended (de facto)"],
          dateSharingEndedDeJure: feature.properties["Date sharing Ended (de jure)"],
          reasonForEnd: feature.properties["Reason for end"],
          postSimultaneumGroup: feature.properties["Group in church after dissolution of Simultaneum"],
          bibliography: feature.properties["Bibliography"],
          weblinks: feature.properties["Weblinks"],
          churchInfo: feature.properties["ChurchInfo"],
      };

      console.log("drawerContent:: ",drawerContent)

      // const includedLayers = ['churchesA', 'churchesB'];

    // if (includedLayers.includes(layerID)) {
        store.dispatch('openDrawer',drawerContent) //Todo:: fix this condition  
    // }
      // Dispatch the action to open the drawer with the content
      // store.dispatch('openDrawer', drawerContent);
    });

  let  years = store.getters["getSharingst"]
  console.log("Dates::", years, store);
  // setMap(projectIds)
  // applyFilter();


  // Handle slider updates
// Configure the slider to include only the years present in the GeoJSON
    const yearSlider = document.getElementById('year-slider');
    const yearLabel = document.getElementById('year-label');
    const toggleFilterButton = document.getElementById('toggle-filter');

   // Configure the slider to include only the years present in the GeoJSON
    yearSlider.min = 0;
    yearSlider.max = years.length - 1;
    yearSlider.value = 0;

    // Filter state
    let filterEnabled = true;

    // Update the year label and map layer when slider changes
    const updateMapForYear = (index) => {
      const year = years[index];
      yearLabel.textContent = `Year: ${year}`;

      // if (map.getLayer('churchesA')) {
      //   map.setFilter('churchesA', ['==', ['get', 'Date sharing Started (de facto)'], year]);
      // }
      // if (map.getLayer('churchesB')) {
      //   map.setFilter('churchesB', ['==', ['get', 'Date sharing Started (de facto)'], year]);
      // }

      // if (map.getLayer('churchesC')) {
      //   map.setFilter('churchesC', ['==', ['get', 'Date sharing Started (de facto)'], year]);
      // }

      // map.setFilter('points-layer', ['<=', ['get', 'year'], year]);

      if (map.getLayer('churchesA')) {
        // map.setFilter('churchesA', ['<=', ['get', 'Date sharing Started (de facto)'], year]);

        // Filter map layer by the 'year' and 'yearEnded' properties
        map.setFilter('churchesA', [
          'all',
          ['<=', ['get', 'Date sharing Started (de facto)'], year],
          ['>=', ['get', 'Date sharing Ended (de facto)'], year]
        ]);
      }
      if (map.getLayer('churchesB')) {
        map.setFilter('churchesB', ['<=', ['get', 'Date sharing Started (de facto)'], year]);
      }

      if (map.getLayer('churchesC')) {
        map.setFilter('churchesC', ['<=', ['get', 'Date sharing Started (de facto)'], year]);
      }

    };

    
    // Enable or disable the year filter
    const toggleFilter = () => {
      filterEnabled = !filterEnabled;

      if (filterEnabled) {
        toggleFilterButton.textContent = 'Disable Filter';
        yearSlider.disabled = false;
        updateMapForYear(parseInt(yearSlider.value, 10));
      } else {
        toggleFilterButton.textContent = 'Enable Filter';
        yearSlider.disabled = true;
        yearLabel.textContent = 'Year: All';
        if (map.getLayer('churchesA')) {
          map.setFilter('churchesA', null); // Remove the filter to show all features
        }

        if (map.getLayer('churchesB')) {
          map.setFilter('churchesB', null); // Remove the filter to show all features
        }

        if (map.getLayer('churchesC')) {
          map.setFilter('churchesC', null); // Remove the filter to show all features
        }
      }
    };

    // Listen for slider input
    yearSlider.addEventListener('input', (event) => {
      if (filterEnabled) {
        const yearIndex = parseInt(event.target.value, 10);
        updateMapForYear(yearIndex);
      }
    });

    // Add filter toggle button functionality
    toggleFilterButton.addEventListener('click', toggleFilter);

    // yearSlider.addEventListener('input', (event) => {
    //   const year = parseInt(event.target.value);
    //   yearLabel.textContent = `Year: ${year}`;
      
    //   // Update the layer filter to show points for the selected year
    //   if (map.getLayer('churchesA')) {
    //     map.setFilter('churchesA', ['==', ['get', 'Date sharing Started (de facto)'], year]);
    //   }
    // });
  });
});


watch(sliderValue, () => {
  console.log("sliderValue::",sliderValue, "StoreLL LL", store)
  applyFilter();
  // store.dispatch('applyFilter'); // Dispatch the action here
});

const applyFilter = () => {
  var dates = store.getters["getSharingst"]
  var selectedDate = dates[sliderValue.value];
  // map.value.setFilter("data-layer", ["==", ["get", "date"], selectedDate]);
  store.getters["getMap"].setFilter('churchesA', ["==", ["get", "Date sharing Started (de facto)"], selectedDate]);
};


//   return {

//   };
// },
//   };
</script>
  
  <style>
#map {
  height: 100vh;
}

#time-slider {
  position: absolute;
  bottom: 30px;
  left: 56%;
  transform: translateX(-50%);
  width: 40%;
  z-index: 10;
}

.controls-container {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(255, 255, 255, 0.8);
      padding: 10px;
      border-radius: 8px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    }
    #year-label {
      font-size: 1.2em;
      text-align: center;
      margin-bottom: 10px;
    }
    #year-slider {
      width: 300px;
    }
    #toggle-filter {
      display: block;
      margin: 10px auto;
      padding: 5px 10px;
      font-size: 1em;
      background-color: #007cbf;
      color: white;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    #toggle-filter:disabled {
      background-color: #aaa;
      cursor: not-allowed; }
</style>